import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { RequestTypes } from './requestTypes'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { normalizeToRequestError } from '@core/utils/errors'

const aiQueryKeys = createQueryKeys('ai', {})

const aiMutationKeys = createMutationKeys('ai', {
  fillWorkflow: {
    mutationKey: [null],
    mutationFn: async ({
      organisationId,
      trackingId,
      text,
      questions,
    }: RequestTypes['fillWorkflow']) => {
      const { data } = await APIAxiosInstance.post(
        `${Project.apiBaseUrl}data/workflow/fill`,
        {
          org_id: organisationId,
          tracking_id: trackingId,
          string: text,
          questions,
        },
      )
      return data
    },
  },
  provideFeedback: {
    mutationKey: [null],
    mutationFn: async (payload: RequestTypes['provideFeedback']) => {
      const { data } = await APIAxiosInstance.post(
        `${Project.apiBaseUrl}data/workflow/feedback`,
        payload,
      )
      return data
    },
  },
  uploadFile: {
    mutationKey: [null],
    mutationFn: async ({
      file,
      organisationId,
      fileType,
    }: RequestTypes['uploadFile']) => {
      const queryString = createQueryKeyString({
        org_id: organisationId,
        file_type: fileType,
      })
      const { data } = await APIAxiosInstance.get(
        `${Project.apiBaseUrl}data/s3/presigned-post-url${queryString}`,
      )

      //!!!Hack Alert: We are using fetch instead of axios for uploading files and media
      // TODO: Find why axios is not working properly for media and file upload
      const fetchOptions = {
        method: 'PUT',
        headers: {
          'content-type': file.type,
        },
        body: file as File,
      }
      const normalizedFetch = normalizeToRequestError(fetch)
      await normalizedFetch(data.url, fetchOptions)

      return data.s3_key
    },
  },
})

export const aiKeys = mergeQueryKeys(aiQueryKeys, aiMutationKeys).ai
